import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bb01f52a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "list-card"
};
const _hoisted_2 = {
  class: "attribute-type"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0,
  class: "mask"
};
const _hoisted_6 = {
  class: "mask-button-list ab-center"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "bottom-content"
};
const _hoisted_9 = {
  key: 0,
  class: "price"
};
import { userStore } from "@/stores/modules/user";
import "./listCard.less";
var ExbitionType;
(function (ExbitionType) {
  ExbitionType[ExbitionType["IEDS"] = 1] = "IEDS";
  ExbitionType[ExbitionType["TREE"] = 2] = "TREE";
  ExbitionType[ExbitionType["DESIGN"] = 5] = "DESIGN";
})(ExbitionType || (ExbitionType = {}));
export default /*#__PURE__*/_defineComponent({
  __name: 'ExibitionCard',
  props: {
    cardData: {
      default: {}
    },
    btn: {
      default: () => [""]
    }
  },
  emits: ["use", "active", "details"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const showMask = ref(false);
    const router = useRouter();
    const {
      cardData,
      btn
    } = toRefs(props);
    const handleUse = () => {
      emit("use", cardData);
    };
    const handleDetails = () => {
      emit("details", cardData);
    };
    const handleEdit = () => {
      switch (cardData.value.sourceType) {
        case ExbitionType.IEDS:
          router.push({
            path: "/tree/" + cardData.value.id,
            query: {
              edit: "true",
              name: cardData.value.name
            }
          });
          break;
        case ExbitionType.TREE:
          router.push({
            path: "/micro-ieds/tenant/" + cardData.value.itemsId,
            query: {
              exhibitionId: cardData.value.itemsId
            }
          });
          break;
        case ExbitionType.DESIGN:
          window.open(`${process.env.VUE_APP_DESIGNER_ADDRESS}/editor?id=${cardData.value.itemsId}&token=${userStore().userInfo.token}`);
          break;
        default:
          router.push({
            path: "/micro-ieds/tenant/" + cardData.value.itemsId,
            query: {
              exhibitionId: cardData.value.itemsId
            }
          });
          break;
      }
    };
    const handleStart = () => {
      switch (cardData.value.sourceType) {
        case 1:
          router.push({
            path: `/business/tree`,
            query: {
              id: cardData.value.id,
              edit: "false",
              clientType: "c",
              templateId: cardData.value.templateId
            }
          });
          break;
        default:
          //统一跳到营销端地址
          window.open(process.env.VUE_APP_BUSINESS_ADDRESS + `?id=${cardData.value.id}&token=${userStore().token}&clear=1`);
          break;
      }
    };
    watch(showMask, val => {
      if (val) {
        emit("active", {
          cardData,
          val
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(btn).includes('delete') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        icon: "close",
        class: "icon-button close-btn",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('delete'))
      })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "header"), _createElementVNode("div", {
        class: "poster-container",
        onMouseover: _cache[1] || (_cache[1] = $event => showMask.value = true),
        onMouseleave: _cache[2] || (_cache[2] = $event => showMask.value = false)
      }, [_createElementVNode("div", _hoisted_2, [_unref(cardData).attributionType == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "公共分类")) : _createCommentVNode("", true), _unref(cardData).attributionType == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "专属分类")) : _createCommentVNode("", true)]), _unref(showMask) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_unref(btn).includes('edit') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        round: "",
        onClick: handleEdit
      }, {
        default: _withCtx(() => [_createTextVNode("编辑")]),
        _: 1
      })) : _createCommentVNode("", true), _unref(btn).includes('details') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "primary",
        round: "",
        onClick: handleDetails
      }, {
        default: _withCtx(() => [_createTextVNode("详情")]),
        _: 1
      })) : _createCommentVNode("", true), _unref(btn).includes('use') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        type: "primary",
        round: "",
        onClick: handleUse
      }, {
        default: _withCtx(() => [_createTextVNode("使用")]),
        _: 1
      })) : _createCommentVNode("", true), _unref(btn).includes('start') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 3,
        type: "primary",
        round: "",
        onClick: handleStart
      }, {
        default: _withCtx(() => [_createTextVNode("启动")]),
        _: 1
      })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("img", {
        src: _unref(cardData).coverImageUrlList && _unref(cardData).coverImageUrlList[0] || _unref(cardData).coverImageUrl || require('@/assets/img/icons/exbitionCard-default.png'),
        class: "poster"
      }, null, 8, _hoisted_7)], 32), _createElementVNode("p", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_unref(cardData).name), 1), _unref(cardData).lowestPrice !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_9, "￥" + _toDisplayString(_unref(cardData).lowestPrice), 1)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "default")]);
    };
  }
});